import React, { useEffect, useState } from "react";
import ReportPanel from "./layout/ReportPanel";
import { Box, Flex } from "@chakra-ui/react";
import DownloadBTN from "../components/DownloadBTN";
import { useDispatch, useSelector } from "react-redux";
import EventReportDetails from "./EventReportDetails";
import { downloadXLSX } from "../services/downloadService";
import DotLoader from "./loaders/DotLoader";
import { setloadTost } from "../redux/slices/toastSlice";

const ReportNewProject = () => {
  const reports = useSelector((state) => state.reports?.reports);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {}, [reports]);

  const selectedEventId = reports?.length > 0 ? reports[0]?.eventId : null;
  const canDownload = Boolean(selectedEventId);

  const handleDownload = async () => {
    if (!canDownload) {
      dispatch(
        setloadTost({
          title: "No report selected",
          description: "Please generate a report before downloading.",
          status: "warning",
        })
      );
      return;
    }

    try {
      setDownloading(true);
      const { blob, contentType, fileName } = await downloadXLSX(selectedEventId);

      const fileBlob = new Blob([blob], { type: contentType });
      const url = window.URL.createObjectURL(fileBlob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (err) {
      dispatch(
        setloadTost({
          title: "Download failed",
          description: err?.message || "Something went wrong while downloading the report.",
          status: "error",
        })
      );
    } finally {
      setDownloading(false);
    }
  };

  return (
    <>
      <ReportPanel setLoading={setLoading} />

      <Box>
        <Flex
          flexDirection={["column", "column", "row"]}
          gap={4}
          justifyContent={["center", "center", "flex-end"]}
          mt={6}
          mb={4}
        >
          {/* <FormControl w={['100%', '65%', '30%', "25%"]}>
                    <Select bg={'#FFFFFF'}  focusBorderColor="0.5px solid brand.primary" _hover={{border: ""}} border={'1px solid #22944E'}
                            _placeholder={{ color: "#8A8C8E" }} color={'brand.primary'} borderRadius={'0'} size={'lg'}
                        >
                            <option value='Filter by Ref Code' selected 
                            >Filter by Code</option>
                            <option value='Filter by Name' >Filter by Name</option>
                            <option value='Filter by Status'>Filter by Status</option>
                        </Select>
                   </FormControl> */}

          <DownloadBTN
            btn_Text="download"
            bg={"#61CE70"}
            onClick={() => handleDownload()}
            isDisabled={!canDownload}
            isLoading={downloading}
          />
        </Flex>

        {loading ? (
          <DotLoader />
        ) : (
          <EventReportDetails eventData={reports[0]} />
        )}
      </Box>
    </>
  );
};

export default ReportNewProject;
